import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";

const stripWww = (h) => h.replace(/^www\./, "");
const resolveBackend = () => {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return env;
  try {
    // Same site served as www / non-www: call the API on the current origin to avoid redirects + CORS.
    if (stripWww(new URL(env).hostname) === stripWww(window.location.hostname)) return window.location.origin;
  } catch {}
  return env;
};
export const BACKEND_URL = resolveBackend();
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const imgSrc = (u, w) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}${w && u.startsWith("/api/files/") ? `?w=${w}` : ""}` : u);

const fmt = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" });
export const euro = (n) => fmt.format(n || 0);

export const errMsg = (e, fallback = "Algo ha salido mal") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Revisa los datos del formulario";
  return fallback;
};

export const CATEGORIES = [
  { id: "ropa", label: "Ropa" },
  { id: "calzado", label: "Calzado" },
  { id: "accesorios", label: "Accesorios" },
];

export const GENDERS = [
  { id: "hombre", label: "Hombre" },
  { id: "mujer", label: "Mujer" },
  { id: "unisex", label: "Unisex" },
  { id: "nino", label: "Niño" },
];

export const ORDER_STATUS = {
  pendiente_pago: { label: "Pendiente de pago", cls: "bg-slate-100 text-slate-600" },
  pagado: { label: "Procesando", cls: "bg-amber-100 text-amber-700" },
  enviado: { label: "Enviado", cls: "bg-blue-100 text-blue-700", pickup: "Listo para recoger" },
  entregado: { label: "Entregado", cls: "bg-emerald-100 text-emerald-700", pickup: "Recogido" },
  cancelado: { label: "Cancelado", cls: "bg-rose-100 text-rose-700" },
};
export const statusLabel = (status, order) => {
  const s = ORDER_STATUS[status] || ORDER_STATUS.pagado;
  return order?.delivery === "recogida" && s.pickup ? s.pickup : s.label;
};
export const isPickup = (order) => order?.delivery === "recogida";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const headers = { ...(config.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) };
      return api.request({ method, url, data, ...config, headers });
    },
    [getToken]
  );
}
